<template>
	<div class="d-flex justify-space-between" style="max-width: 300px">
		<div>
			<div class="d-flex flex-row">
				<span class="text-h6 primary--text text--lighten-4 mr-2"> {{ muayThai.rating }} </span>
				<v-rating
					v-model="muayThai.rating"
					background-color="white"
					color="orange accent-4"
					dense
					half-increments
					hover
					size="12"
					class="mb-n2"
				></v-rating>
			</div>
			<div class="text-caption grey--text">{{ `${muayThai.userRating}k Ratings` }}</div>
		</div>
		<v-divider vertical dark></v-divider>
		<div>
			<span class="text-h6 primary--text text--lighten-4"> {{ muayThai.RTP }} </span>
			<div class="text-caption grey--text">RTP %</div>
		</div>
		<v-divider vertical dark></v-divider>
		<div>
			<span class="text-h6 primary--text text--lighten-4"> {{ `${muayThai.players}k` }} </span>
			<div class="text-caption grey--text">Players</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {}
	},
	computed: {
		muayThai() {
			return this.$store.getters["Casino/muayThai"]
		},
	},
}
</script>

<style></style>
